import {
    Row,
    Col,
    Card,

    Button,

    Form,
    Input,

    DatePicker,
    Select,
    InputNumber,
} from "antd";

import React, { useState, useEffect, } from "react";
import { Link } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
const { Option } = Select;
const { RangePicker } = DatePicker;
const Search = Input.Search;
function LoyalityPointManager() {
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [searchText, setSearchText] = useState("");
    const { request } = useRequest();
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [visible, setVisible] = useState(false);
    const [selected, setSelected] = useState();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const debouncedSearchText = useDebounce(searchText, 300);
    const [form] = Form.useForm();







    useEffect(() => {
        setLoading(true);
        fetchData(pagination);
    }, [refresh, debouncedSearchText, startDate, endDate]);


    const fetchData = (pagination, filters) => {
        const filterActive = filters ? filters.is_active : null;
        request({
            url: `/admin/price-matrix/loyality-point`,
            method: "GET",
            onSuccess: (data) => {
                const dataUpdate = data.data
                form.setFieldsValue({ ...dataUpdate })
                console.log(dataUpdate, "dataUpdate")
                setLoading(false);

            },
            onError: (error) => {
                console.log(error);
                ShowToast(error, Severty.ERROR);
            },
        });
    };




    const onCreate = (values) => {
        const { redemptionRate, loyalityPointRedemption, conversionRate, loyalityPointConversion } = values;
        const payload = {};

        setLoading(true);

        payload.redemptionRate = redemptionRate;
        payload.loyalityPointRedemption = loyalityPointRedemption;
        payload.conversionRate = conversionRate;
        payload.loyalityPointConversion = loyalityPointConversion;

        request({
            url: `/admin/price-matrix/edit-loyality-point`,
            method: `POST`,
            data: payload,
            onSuccess: (data) => {
                setLoading(false);
                if (data.status) {
                    ShowToast(data.message, Severty.SUCCESS);
                    setSelected();
                    setVisible(false);
                    setSearchText("");
                    setRefresh((prev) => !prev)
                    // hide()
                } else {
                    ShowToast(data.message, Severty.ERROR);
                }
            },
            onError: (error) => {
                ShowToast(error.response.data.message, Severty.ERROR);
                // console.log(error.response.data, "Error")
                setLoading(false);
            },
            // onErrorSubmit: (data) => {
            //   console.log(data)
            // }
        });
        // console.log(values)
    };

    return (
        <Main>
            <div className="tabled">
                <Row>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="Loyality Point Management"

                        > 
                                <Form id="create" form={form} onFinish={onCreate} layout="vertical">
                                    <Row gutter={12}>
                                        <Col span={12} xs={12} md={12}>
                                            <Form.Item
                                                label="Loyality Point Conversion"
                                                name="loyalityPointConversion"
                                                rules={[
                                                    { required: true, message: "Please input the loyalityPoint!" },

                                                ]}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12} xs={12} md={12}>
                                            <Form.Item
                                                label="Conversion Rate"
                                                name="conversionRate"
                                                rules={[
                                                    { required: true, message: "Please input the Conversion rate!" },

                                                ]}
                                            >
                                                <InputNumber />
                                            </Form.Item>




                                        </Col>
                                        <Col span={12} xs={12} md={12}>
                                            <Form.Item
                                                label="Loyality Point Redemption "
                                                name="loyalityPointRedemption"
                                                rules={[
                                                    { required: true, message: "Please input the Loyality Point Redemption!" },

                                                ]}
                                            >
                                                <InputNumber />
                                            </Form.Item>




                                        </Col>
                                        <Col span={12} xs={12} md={12}>
                                            <Form.Item
                                                label="Redemption Rate "
                                                name="redemptionRate"
                                                rules={[
                                                    { required: true, message: "Please input the redemption rate!" },

                                                ]}
                                            >
                                                <InputNumber />
                                            </Form.Item>




                                        </Col>
                                        <Col>
                                            <Form.Item className="footer-btn-cls">
                                                <Button type="primary" htmlType="submit">Submit</Button>
                                                {/* <Link to={"/taxi-admin/loyalty-point-manager"}>

                                                    <Button type="primary" htmlType="back">Back</Button>
                                                </Link> */}

                                            </Form.Item>
                                        </Col>



                                    </Row>
                                </Form> 
                        </Card>
                    </Col>
                </Row>
            </div>


        </Main >
    );
}








export default LoyalityPointManager;
